// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { IconWrapper } from "@insite/mobius/Icon";
import CaretRight from "@werner/XDL/Icons/CaretRight";
import { css } from "styled-components";

headerStyles.titleWrapper = {
    width: [8, 8, 6, 6, 6],
};

headerStyles.buttonSet = {
    width: [4, 4, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

headerStyles.buttonSetHidden = {
    ...headerStyles.buttonSetHidden,
    below: "lg",
    css: css`
        display: flex;
    `,
};
headerStyles.menuHidden = {
    ...headerStyles.menuHidden,
    above: "md",
};

headerStyles.cancelButton = {
    variant: "secondary",
};
